import baseMessage from './baseMessage'

export const ES_MX = {
  message: {
    ...baseMessage,
    label: {
      dni: 'RFC',
      userHint: 'Se puede buscar por Nombres, Apellidos, Documento de identidad'
    },
    searchComponent: {
      fileNumber: 'Número de expediente',
    }
  }
}
